module.exports = __webpack_public_path__ + "img/IMG_9_Secondary_Healing_Progress_D3.066d1825.jpg";